import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	SurveyView
} from '../../components/support/';

class Survey extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <SurveyView />
					</Col>
				</Row>
			</div>
		);
	}
}

export default Survey;
